import * as DetailPanels from '.'
import detailPanelStyles from '../../assets/style/scss/detail-panel.scss'

const mapStateToProps = (state, ownProps) => {
  const { requestComponent, detailPanels } = ownProps
  const { name, props, closing } = state.app.detailPanel
  return {
    name,
    props,
    closing,
    requestComponent,
    detailPanels,
  }
}

class DetailPanelContainer extends Component {
  constructor(props) {
    super(props)
    this.state = { closePanel: false }
  }

  componentDidUpdate(prevProps) {
    const { closing } = this.props

    if (!prevProps.closing && closing) {
      this.setState({ closePanel: true })
    }
    if (prevProps.closing && !closing) {
      this.setState({ closePanel: false })
    }
  }

  render() {
    const { name, props, requestComponent, detailPanels } = this.props
    const { closePanel } = this.state
    const Component = DetailPanels[name]
    let output = null

    if (!closePanel && name) {
      output = Component ? (
        <Component
          requestComponent={requestComponent}
          detailPanels={detailPanels}
          detailPanelName={name}
          {...props}
        />
      ) : null
    }

    return output
  }
}
export default connect(mapStateToProps)(DetailPanelContainer)
